{
  "slug": "is-iq-genetic",
  "title": "Is IQ genetic?",
  "description": "Learn how genes and environment both contribute to cognitive differences, and what heritability does—and does not—mean.",
  "summary": "Cognitive ability is influenced by many genetic variants and many environmental factors. The two interact throughout development.",
  "sections": [
    {
      "heading": "Many influences, not one IQ gene",
      "paragraphs": [
        "Genetic differences contribute to variation in cognitive test scores, but there is no single gene that determines a person’s IQ. Effects are distributed across many variants, each usually contributing very little.",
        "Biology develops within an environment. Nutrition, health, education, safety, stress, family resources, and opportunity can affect how cognitive skills develop and are expressed."
      ]
    },
    {
      "heading": "What heritability means",
      "paragraphs": [
        "Heritability is a population statistic describing how much observed variation is associated with genetic differences under particular conditions. It does not say what percentage of one person’s intelligence is genetic.",
        "A trait can be heritable and still respond to environmental change. Estimates vary across ages, populations, and social conditions."
      ]
    },
    {
      "heading": "Avoid deterministic conclusions",
      "paragraphs": [
        "A DNA result cannot provide a complete or definitive prediction of an individual’s cognitive future. Group averages cannot determine an individual’s potential.",
        "Supportive environments, effective education, healthcare, and opportunity remain meaningful. Responsible interpretation never uses IQ to rank human worth."
      ]
    }
  ],
  "faqs": [
    {
      "question": "How much of IQ is inherited?",
      "answer": "There is no single percentage for an individual. Population estimates vary by age, environment, population, and study method."
    },
    {
      "question": "Can environment affect IQ?",
      "answer": "Yes. Education, health, nutrition, stress, language, and opportunity can influence development and test performance."
    }
  ],
  "related": ["can-iq-change-over-time", "what-is-iq", "iq-vs-intelligence"]
}
